import WebLayout from './ColorPickerLayout.web'
import MobileLayout from './ColorPickerLayout.mobile'
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
